import styled from "styled-components";
import { Input, Select, Divider,Tooltip } from "antd";

export const ContentDivider = styled(Divider)`
  border: solid 0.5px ${props => props.theme.colors.border};
  margin-top: 20px;
  margin-bottom: 15px;
`;

export const SeachImage = styled.img`
 width: 14px;
 height:14px;
`;
export const QueryResult = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  margin: ${props => props.theme.spacing.paddings.webTwiceBase};
  font-weight: ${props => props.theme.fontWeight.bold};
  display: block;
`;

export const Blocks = styled.div`
${({ h }) => h && `height:${h}px`}
${({ flex }) =>
  flex === 2 ? `display:flex;flex-direction:column` : `display:flex;`}
${({ overflow }) =>
  overflow == "scroll" ? `overflow:scroll` : `overflow:auto`}
${({ center }) => center && `justify-content:center;align-items:center;`}
`;

export const Searchbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0px;
  flex-wrap: wrap;
  @media only screen and (max-width: 990px) {
    flex-wrap: wrap;
    border: none;
  }
`;

export const GrantsSearchContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};  
  @media only screen and (max-width: 990px) {
    border: none;
  }
`;

export const SearchInput = styled(Input)`
  height: 40px;
  ${props => props.mobileMargin && "margin: 20px 24px 20px 0px;"};
  .ant-input {
    border-radius: 0px;
  }
`;

export const MobileGrantWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: flex;
    background: blue;
    width: 100%;
  }
`;


export const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 800px;
  // background:white;
`;

export const ModalContainer = styled.div`
  overflow: hidden;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.6);
`;

// export const TimeFrame = styled.div`
// width: 200px;
// margin-left:20px
// height: 32px;
// border-radius:4px;
// border: 1px solid #d4d4d4;
// line-height:32px;
// padding-left:20px;
// background:white;
// font-size:14px;
// font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
// color:#d4d4d4`
// ;

export const SelectTab = styled(Select)`
  width: 200px;
  margin-left: 10px;
  max-width: 220px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  &.ant-select-focused {
    border: 1px solid #505050 !important;
    outline-color: #505050 !important;
    outline-width: 1px !important;
  }
  .ant-select-selection__placeholder,
  .ant-select-search__field__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.placeholder};
  }
  .ant-select-selection--multiple .ant-select-selection__placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.placeholder};
  }

  .ant-select-selection {
    border-radius: 0px;
    overflow: hidden;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.placeholder};
    .ant-select-selection__rendered {
      line-height: 40px !important;
    }
    &:hover {
      border: 1px solid ${props => props.theme.colors.lightGrey};
    }
  }

  .ant-select-selection--multiple .ant-select-selection__placeholder {
  }
  .ant-select-arrow {
    color: ${props => props.theme.colors.dropdownArrow};
    width: 40px;
    height: 100%;
    top: 6px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${props => props.theme.colors.border};
    background:  ${props => props.theme.colors.greyColor};
  }
  .ant-select-selection--multiple {
    min-height: 40px;
    height: auto;
  }
  .ant-select-selection {
    border-radius: 0px;
    padding-right: 22px;
  }

  .ant-select-selection--multiple > ul > li,
  .ant-select-selection--multiple .ant-select-selection__rendered > ul {
    text-overflow: ellipsis;
  }
  .ant-select-selection--multiple > ul > li,
  .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
    height:auto;
  }

  .ant-select-selection--multiple .ant-select-selection__choice {
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0;
    width: 170px;
  }
  @media only screen and (min-width: 728px) and (max-width: 1023px) {
    width: 200px;
  }
  @media only screen and (min-width: 1023px) and (max-width: 1439px) {
    width: 170px;
  }
`;

export const GrantSearchLabel = styled.label`
  line-height: 40px;
  margin-left: ${props => (props.first ? `0px` : `20px`)};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (max-width: 576px) {
    margin: 0px;
  }
`;

export const HiddenFrequency = styled.div`
  display: none;
`;

export const ToolTipContainer = styled(Tooltip)`
&&{
  .ant-tooltip{
    width:100% !important;
  }
}
  .ant-tooltip-content{ 
    @media only screen and (max-width: 576px){
      display: none !important;
  }
}
`;

